import { css, styled } from '../../../core/theme/styled';
import { StyledHeader } from '../../organisms/Header/Header.styles';
import { StyledMain } from '../ContentBody/ContentBody';
import { FooterLegalDisclaimer } from '../Footer/Footer';

interface Props {
  zIndex?: number;
  isRedirectMode?: boolean;
}

const sharedDesktopStyles = css<Props>`
  top: 50%;
  left: 50%;
  ${({ isRedirectMode }) =>
    isRedirectMode &&
    `
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
  `}
  border-radius: ${(props) => props.theme.sizes.xxsmall};
`;

export const TLPageWrapper = styled.div<Props>`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  position: absolute;
  width: 100%;
  z-index: ${(props) => (props.zIndex ? props.zIndex : '')};
  background: ${(props) => props.theme.configuration.backgroundColor};

  ${({ theme }) =>
    css`
      @media ${theme.device.tablet} and (min-height: 600px) {
        ${sharedDesktopStyles}
        margin: 2rem;
        height: calc(100% - 4rem);
        width: calc(100% - 4rem);
        max-width: 960px;
        max-height: 900px;
        transform: translate(calc(-50% - 2rem), calc(-50% - 2rem));

        ${StyledHeader}, ${StyledMain}, ${FooterLegalDisclaimer} {
          padding-left: ${(props) => props.theme.sizes.medium};
          padding-right: ${(props) => props.theme.sizes.medium};
        }
      }
    `}
`;
